import React from "react"
import Image from "../atoms/image"
import textData from "../../data/textData"
import styled from "styled-components"
import Button, { BackButton } from "../atoms/button"
import Comment from "../atoms/comment"
import Progress from "../organisms/progress"
import QHeader from "../molecules/q-header"
import media from "styled-media-query"
import Choice from "../molecules/choice"
import AText from "../atoms/a-text"
import MediaQuery from "react-responsive"

const Wrap = styled.div`
  ${media.greaterThan("small")`
    display: flex;
  `}
`
const SPWrap = styled.div`
  background-color: #e8f0fb;
  display: flex;
  margin: 0 -16px 12px -16px;
  padding: 0 16px;
  ${media.greaterThan("small")`
    background-color: transparent;
    display: block;
    margin: 0;
    padding: 0;
  `}
`
const PCLeftWrap = styled.div`
  ${media.greaterThan("small")`
    margin-right: 40px;
    width: 51%;
  `}
`
const PCRightWrap = styled.div`
  ${media.greaterThan("small")`
    flex:1;
    margin: 16px 0;
  `}
`
const ChoiceWrap = styled.div`
  height: 32px;
  margin: 16px 2px 0 0;
  ${media.greaterThan("small")`
    height: 45px;
    margin: auto;
    width: 308px;
  `}
`
const StyledGImage = styled.div`
  background-color: #e8f0fb;
  flex: 1;
  height: 100%;
  margin: auto 0 0 0;
  ${media.greaterThan("small")`
    background-color: transparent;
    margin: 4px 0 0 0;
  `}
`
const StyledADiv = styled.div`
  background-color: #e8f0fb;
  margin: 19px 0 30px 0;
  width: 60.9%;
  ${media.greaterThan("small")`
    border-radius: 0px 0px 5px 5px;
    margin: 0;
    padding-bottom: 18px;
    width: 100%;
  `}
`
const StyledButtonArea = styled.div`
  display: flex;
  margin: 28px 0 12px 0;
  ${media.greaterThan("small")`
    margin: 32px 0;
  `}
`
const FlexButton = styled(Button)`
  margin-left: 12px;
`

const AnswerTemplate = props => {
  const index = props.index
  const data = textData[index]
  const correct = props.correct
  const gImageNameASP = props.gImageNameASP
  const gImageNameAPC = props.gImageNameAPC
  const gImageNameIASP = props.gImageNameIASP
  const gImageNameIAPC = props.gImageNameIAPC
  const imgName = "aImage" + data.no
  const resultList = props.resultList
  const toNext = props.toNext
  const toIndex = props.toIndex
  const aText = props.aText
  const buttonText = props.buttonText

  let correctData
  data.choices.map(element => {
    if (element.correct) {
      return (correctData = element)
    }
  })

  return (
    <>
      <Progress index={index} resultList={resultList} />
      <Wrap>
        <PCLeftWrap>
          <QHeader index={index} isAnswer={true} />
          <SPWrap>
            <StyledADiv>
              <AText text={aText} answer={correctData.index} />
              {data.choices.map((element, index) => {
                if (element.correct) {
                  return (
                    <ChoiceWrap key={index}>
                      <Choice key={index} element={element} isAnswer={true} />
                    </ChoiceWrap>
                  )
                }
              })}
            </StyledADiv>
            <StyledGImage>
              {correct && (
                <>
                  <MediaQuery query="(max-width: 449px)">
                    <Image name={gImageNameASP} />
                  </MediaQuery>
                  <MediaQuery query="(min-width: 450px)">
                    <Image name={gImageNameAPC} />
                  </MediaQuery>
                </>
              )}
              {!correct && (
                <>
                  <MediaQuery query="(max-width: 449px)">
                    <Image name={gImageNameIASP} />
                  </MediaQuery>
                  <MediaQuery query="(min-width: 450px)">
                    <Image name={gImageNameIAPC} />
                  </MediaQuery>
                </>
              )}
            </StyledGImage>
          </SPWrap>
        </PCLeftWrap>
        <PCRightWrap>
          <Image name={imgName} />
          <Comment>
            <p>{data.answer}</p>
            {data.notes && <p style={{ margin: 0 }}>{data.notes}</p>}
          </Comment>
          <StyledButtonArea>
            {correct && <Button onClick={toNext}>{buttonText}</Button>}
            {!correct && (
              <>
                <BackButton onClick={toIndex}>最初からやり直す？</BackButton>
                <FlexButton onClick={toNext}>{buttonText}</FlexButton>
              </>
            )}
          </StyledButtonArea>
        </PCRightWrap>
      </Wrap>
    </>
  )
}

export default AnswerTemplate
